import { applyModuleReleaseConfig } from '../utils/moduleRelease';

/**
 * Module cards - same data as Learning Hub home (images, order, NEW badge).
 * Release gating for production is applied via `src/config/liveModules.js`.
 */
const MODULE_DEFINITIONS = [
  {
    id: 'intro-module',
    title: 'Introduction Module',
    description: 'Breaking Barriers & Building Opportunity: Foundations for Systems Change. Start here.',
    progress: 0,
    status: 'not-started',
    color: 'blue',
    icon: '🌟',
    duration: '~15 min',
    lessons: 4,
    isStudyModule: true,
    isNew: false,
    imageUrl: `${process.env.PUBLIC_URL || ''}/images/module_1.png`,
  },
  {
    id: 'workplace-module',
    title: 'Building Workplace Bridges',
    description: 'Breaking Barriers: Understanding Systemic Workplace Challenges.',
    progress: 0,
    status: 'not-started',
    color: 'purple',
    icon: '💼',
    duration: '2 weeks',
    lessons: 5,
    isStudyModule: true,
    isNew: false,
    imageUrl: `${process.env.PUBLIC_URL || ''}/images/module_2.png`,
  },
  {
    id: 'educator-module',
    title: 'Educator Module',
    description: 'Supporting learners and fostering inclusive STEMM education.',
    progress: 0,
    status: 'not-started',
    color: 'teal',
    icon: '📚',
    duration: '~40 min',
    lessons: 7,
    isStudyModule: true,
    isNew: false,
    imageUrl: `${process.env.PUBLIC_URL || ''}/images/module_5.png`,
  },
  {
    id: 'community-module',
    title: 'Community Module',
    description: 'Breaking Barriers: Community norms, care, and STEMM pathways.',
    progress: 0,
    status: 'not-started',
    color: 'orange',
    icon: '🤝',
    duration: '~40 min',
    lessons: 7,
    isStudyModule: true,
    isNew: false,
    imageUrl: `${process.env.PUBLIC_URL || ''}/images/module_3.png`,
  },
  {
    id: 'parent-module',
    title: 'Parent Module',
    description: 'Before the Gate: A parent lens on the STEMM pathway.',
    progress: 0,
    status: 'not-started',
    color: 'pink',
    icon: '👨‍👩‍👧',
    duration: '~45 min',
    lessons: 6,
    isStudyModule: true,
    isNew: true,
    imageUrl: `${process.env.PUBLIC_URL || ''}/images/module_4.png`,
  },
];

const ALL_MODULE_IDS = MODULE_DEFINITIONS.map((m) => m.id);

export const MODULES_CATALOG = MODULE_DEFINITIONS.map((module) =>
  applyModuleReleaseConfig(module, ALL_MODULE_IDS)
);
